// Activity module uses the shared rootStore.
// This file re-exports the root state type so selectors can be typed correctly.
import { useSelector } from 'react-redux';
import rootStore from '../../commonUtils/Redux/Global/rootStore';

export type ActivityRootState = ReturnType<typeof rootStore.getState>;
export type ActivityAppDispatch = typeof rootStore.dispatch;

export const useActivitySelector = <T>(selector: (state: ActivityRootState) => T): T =>
  useSelector<ActivityRootState, T>(selector);

export default rootStore;
